module.exports = __webpack_public_path__ + "img/head-shoulders_active.e0166a24.png";